import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Global Components
import Button from "./components/block/Button.vue";

// Global styles
import "./assets/scss/main.scss";

const app = createApp(App);

app.use(store);

app.use(router);

app.component("Button", Button);

app.mount("#app");
